export default "__VITE_ASSET__ChrHHg4g__"